import Cookies from 'js-cookie'

const SESSION_COOKIE = 'brixture_session'

export const saveSessionToken = (token) => {
  Cookies.set(SESSION_COOKIE, token, {
    expires: 7,
    sameSite: 'strict',
    secure: window.location.protocol === 'https:'
  })
}

export const getSessionToken = () => Cookies.get(SESSION_COOKIE) ?? null

export const deleteSessionToken = () => {
  Cookies.remove(SESSION_COOKIE)
  Cookies.remove('serverless')
}